var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBalloon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.423,
    height: 38.467,
    viewBox: "0 0 24.423 38.467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    id: "Trac\\xE9_152",
    "data-name": "Trac\\xE9 152",
    d: "M15.212,24.384a12.064,12.064,0,0,0,9.769-12.173,9.769,9.769,0,1,0-19.539,0A12.064,12.064,0,0,0,15.212,24.384ZM27.423,12.212A14.508,14.508,0,0,1,16.384,26.624l.6,1.189a.612.612,0,0,1-1.094.547l-.02-.042a5.93,5.93,0,0,0,.09.708,9.849,9.849,0,0,0,1.023,2.45,5.088,5.088,0,0,1,.186,3.979,11.55,11.55,0,0,1-1.436,2.723l-.01.017a.611.611,0,1,1-1.016-.679,10.306,10.306,0,0,0,1.3-2.45,3.838,3.838,0,0,0-.12-3.043l-.032-.068a10.552,10.552,0,0,1-1.094-2.691,7.759,7.759,0,0,1-.127-1.1l-.1.2a.611.611,0,1,1-1.092-.547l.6-1.189A14.508,14.508,0,0,1,3,12.212a12.212,12.212,0,0,1,24.423,0ZM10.478,11A4.892,4.892,0,0,1,14,7.478a1.5,1.5,0,0,0,1.209-1.373A1.081,1.081,0,0,0,14,4.985,7.334,7.334,0,0,0,7.987,11a1.078,1.078,0,0,0,1.119,1.216A1.5,1.5,0,0,0,10.478,11Z",
    transform: "translate(-3)",
    fill: "black",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBalloon);
export default __webpack_public_path__ + "static/media/icon-balloon.541f464d0512759a226820613b5b80e1.svg";
export { ForwardRef as ReactComponent };